__turbopack_context__.v({
  "className": "montserrat_51aeb706-module__dT7NDG__className",
  "variable": "montserrat_51aeb706-module__dT7NDG__variable",
});
